// extracted by css-extract-rspack-plugin
    if(module.hot) {
      // 1745320452813
      var cssReload = require("!../../../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModule":true});
      module.hot.dispose(cssReload);
      ;
    }
  